<template>
    <draggable class="row m-0 p-0"
               v-model="valueTemp"
               v-bind="{ handle:'.regions-handle', animation:150 }">

        <b-col v-for="(item, index) in valueTemp"
               :key="item.Id" 
               class="m-0"
               :class="index % 2 == 1 ? 'pr-0' : 'pl-0' "
               cols="6">

            <b-row class="p-0 ml-15 v-center">

                <b-col md="auto" class="sorting-list-subname m-0 pl-0 pr-0">
                    {{item.Name}}
                </b-col>

                <b-col md="auto" class="m-0 p-0" @click="openNavigator(item)">
                    <font-awesome-icon icon="location-arrow" class="sorting-icon pointer"/>
                </b-col>

                <b-col md="auto" class="regions-handle m-0 p-0">
                    <font-awesome-icon icon="arrows-alt" class="sorting-icon pointer" />
                </b-col>

                <b-col cols="12" class="m-0 p-0">
                    <hr class="hr-sub">
                </b-col>
            </b-row>
        </b-col>

    </draggable>
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        valueTemp: {
			get: function() {
				return this.value;
			},
			set: function(value) {
				this.$emit('update', value);
			}
		}
    },
    methods: {
        openNavigator: function(region) {
            window.open(`https://yandex.ru/maps/?text=${region.Location.Latitude}%2C%20%20${region.Location.Longitude}`);
        }
    }
}
</script>